import React, { useEffect } from 'react';
import { MainTopBanner } from '../components/main/MainTopBanner';
import { MainNoticeContainer } from '../components/main/MainNoticeContainer';
import { MainOverview } from '../components/main/MainOverview';
import { MainYoutubeStaticContainer } from '../components/main/MainYoutubeStaticContainer';
import { DiscordBannerFixed } from 'components/main/DiscordBannerFixed';

export const MainScreen = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <>
            <DiscordBannerFixed />
            <MainTopBanner />
            <div style={{ maxWidth: '1240px', margin: '0 auto' }}>
                <MainNoticeContainer />
                <MainYoutubeStaticContainer />
            </div>
            <div style={{ marginTop: '76px' }}>
                <MainOverview
                    imgUrl='main_overview_1.webp'
                    heading='SOBRE'
                    description='Bem-vindo ao mundo de LUTADOR METAMORFO. Aprenda sobre a história e os elementos básicos do jogo.'
                    buttonText='VEJA MAIS'
                    buttonLink='/'
                />
                <MainOverview
                    imgUrl='main_overview_2.webp'
                    align='right'
                    heading='Guia de Jogo'
                    description='Aprenda sobre os controles, itens e vários sistemas do jogo de luta LUTADOR METAMORFO.'
                    buttonText='VEJA MAIS'
                    buttonLink='/'
                />
                <MainOverview
                    imgUrl='main_overview_3.webp'
                    heading='VOCÊ ESTÁ PRONTO PARA ENTRAR NA BATALHA?'
                    description='Você está pronto para lutar? Ótimo. Baixe o jogo, entre na batalha e descubra quem é o melhor lutador.'
                    buttonText='JOGUE AGORA'
                    buttonLink='/'
                />
            </div>
        </>
    );
};
